import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import TrailSafeLogo from 'assets/TrailSafe_TempLogo.png';
import TSButton from 'components/common/Button/Button';
import { ROUTES } from 'constants/RoutePaths';

// Deliberately not the shared Dashboard/DashboardLayout shell — see
// docs/adr/0006. Recipients of a Welfare Check SMS link often have no
// Trail Safe account at all, so this stays free of app nav/sign-in chrome.
const WelfareCheckLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex justify-between items-center gap-4 px-[32px] py-[10px] border-b border-[var(--Grey-30)]">
        <img className="w-[120px]" alt="TrailSafe Logo" src={TrailSafeLogo} />
        <TSButton
          btnText="Go to main trail site"
          btnVariant="outlined"
          btnSize="small"
          onClickFunc={() => navigate(`/${ROUTES.HOME}`)}
        />
      </div>
      <div className="flex-1 flex items-center justify-center p-5">
        <div className="w-full" style={{ maxWidth: '480px' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default WelfareCheckLayout;
